import General from '@/mixins/general';
import axios from "axios";

const TODO_API_URI = 'https://api.wvr-law.de/post/index.php';

export default {
    mixins: [General],
    methods: {
        createToDoVorgang(data) {
/*
            // this.sendGaEvent();

            let _this = this;

            // Conversion-Event: Lead
            this.$gtag.event('Formular abgeschickt', {
                'event_category': this.$global.gaCat,
                'event_label': null
            });
            window.uetq = window.uetq || [];
            window.uetq.push('event', 'Formular abgeschickt', {'event_category': this.$global.gaCat});
			window.fbq('track', 'Lead');

            // Conversion-Event: Qualifizierter Lead
            let qualiArray = ["Barzahlung","Voll bezahlt","Darlehen"];
            if( data.rsv_bei_kauf_vorhanden === "Ja" && qualiArray.includes(data.finanzierungsart) && data.automarke !== "Sonstiges" ) {
                this.$gtag.event('Qualifizierter Lead', { 'event_category': _this.$global.gaCat, 'event_label': null, 'value' : 740 });
                window.uetq.push('event', 'Qualifizierter Lead', {'event_category': this.$global.gaCat, 'event_value': 740});
				window.fbq('track', 'Qualifizierter Lead');
            }
            // Conversion-Event: Qualifizierter Lead (Mercedes)
			/*
            else if( data.rsv_bei_kauf_vorhanden !== "Ja" && qualiArray.includes(data.finanzierungsart) && data.automarke === "Mercedes-Benz" ) {
                this.$gtag.event('Qualifizierter Lead', { 'event_category': _this.$global.gaCat, 'event_label': null, 'value' : 200 });
                window.uetq.push('event', 'Qualifizierter Lead', {'event_category': this.$global.gaCat, 'event_value': 200});
            }
			*/

            // Google Get-Parameter
		/*
            if(this.$route.query.source) { data.ad_source = this.$route.query.source; }
            if(this.$route.query.campaignid) { data.ad_campaignid = this.$route.query.campaignid; }
            if(this.$route.query.adgroupid) { data.ad_adgroupid = this.$route.query.adgroupid; }
            if(this.$route.query.gclid) { data.gclid = this.$route.query.gclid; }

            // AWIN
            window.AWIN = window.AWIN||{};
            window.AWIN.Tracking = window.AWIN.Tracking||{};
            let now = new Date();
            data.awin_id = now.getFullYear()+(0+""+(now.getMonth()+1)).substr(-2,2)+(0+""+now.getDate()).substr(-2,2)+""+Math.floor(Math.random() * 100000000);
            window.AWIN.Tracking.Sale = {};
            window.AWIN.Tracking.Sale.amount = "1";
            var channel = "Organic";
            window.AWIN.Tracking.Sale.currency = "EUR";
            window.AWIN.Tracking.Sale.orderRef = data.awin_id;
            window.AWIN.Tracking.Sale.parts = "DEFAULT:1";
            window.AWIN.Tracking.Sale.voucher = "";
            window.AWIN.Tracking.Sale.test = "0";
            if (this.$route.query.awc) localStorage.setItem('awin_param',this.$route.query.awc);
            if (localStorage.getItem('awin_param')) {
              data.ad_adgroupid = localStorage.getItem('awin_param');
              data.ad_source = 'awin';
              channel = "Aw";
            } else if (data.ad_source) {
              if (data.ad_source == 'facebook') {
                channel = "social";
              } else {
                channel = "ppcgeneric";
              }
            }
            channel = "Aw"; // <---- Trackingweichen-Fix
            window.AWIN.Tracking.Sale.channel = channel;
            window.AWIN.Tracking.run();
            window.AWIN.Sale = {};
            var conv_pix = document.createElement('img');
            conv_pix.setAttribute("border", "0");
            conv_pix.setAttribute("height", "0");
            conv_pix.setAttribute("src", "https://www.awin1.com/sread.img?tt=ns&tv=2&merchant=23519&amount=1&ch="+channel+"&cr=EUR&parts=DEFAULT:1&ref="+data.awin_id+"&vc=");
            conv_pix.setAttribute("style", "display: none;");
            conv_pix.setAttribute("width", "0");
            document.body.appendChild(conv_pix);
		*/

            let s = new URLSearchParams(this.clearObjectforSerialize(data)).toString();
            if (process.env.VUE_APP_ENV === "prod") {
                axios.post(
                    TODO_API_URI,
                    s
                ).then(response => {
                    return response.status != 200
                }).catch(err => {
                    console.log(err);
                    return true;
                });
            } else {
                console.log('Kein Submit: an '+TODO_API_URI+" mit "+s);
                return true;
            }
        },
    },
};
